import React, { useState, lazy, Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./Components/Header/Navbar";
import FooterNew from "./Components/Footer/FooterNew";
import ScrollToTop from "./ScrollToTop";
import BackToTopButton from "./Components/ScrollToTopButton/BackToTopButton";
// import MetaDescription from "./Components/Meta/Metadescription";
// import SchemaRenderer from "./Components/Schema/SchemaRenderer";
import VideoSchema from "./Components/Schema/VideoSchema";
import MetaRouteWrapper from "./Components/Meta/MetaRouteWrapper";
import BlogSeoWrapper from "./Pages/Blogs/BlogSeoWrapper";
import BreadcrumbSchema from "./Components/Breadcrumb Schema/BreadcrumbSchema";
import "lenis/dist/lenis.css";

import FaqSchema from "./Components/SEO/FaqSchema";
import faqsByRoute from "./Components/FAQ/faqsByRoute";

const CookieConsent = lazy(() => import("./Pages/Cookies/CookieConsent"));
const FaqSection = lazy(() => import("./Components/FAQ/FaqSection"));
const FloatingContactActions = lazy(() => import("./Components/Colleges/FloatingContactActions"));
// import HomeUpdate from "./Pages/Home/HomeUpdate";

// ✅ Lazy Imports (Code Splitting)
const BlogListPage = lazy(() => import("./Pages/Blogs/BlogListPage"));
const BlogPage = lazy(() => import("./Pages/Blogs/BlogPage"));
const Blog26 = lazy(() => import("./Pages/Blogs/Pages/emi-calculator"));
const EmployeePage = lazy(() => import("./Pages/Blogs/AuthorPage"));
const Innovation = lazy(() => import("./Pages/Innovation/Innovation"));
const Consulting = lazy(() => import("./Pages/Consulting/Consulting"));
const ForUniversities = lazy(() => import("./Pages/ForUniversities/ForUniversities"));
const HomeUpdate = lazy(() => import("./Pages/Home/HomeUpdate"));
const TrainingNew = lazy(() => import("./Pages/Training/TrainingNew"));
const PPL = lazy(() => import("./Pages/Training/Pilot Training/PPL"));
const Cpl = lazy(() => import("./Pages/Landing/Cpl"));
const TypeRating = lazy(() => import("./Pages/Training/Pilot Training/TypeRating"));
const AboutUs = lazy(() => import("./Pages/About Us/AboutUs"));
const OurGovernance = lazy(() => import("./Pages/About Us/Pages/OurGovernance"));
const OurValues = lazy(() => import("./Pages/About Us/Pages/OurValues"));
const OurPresence = lazy(() => import("./Pages/About Us/Pages/OurPresence"));
const Colleges = lazy(() => import("./Pages/Colleges/Colleges"));
const BbaAviation = lazy(() => import("./Pages/Training/Degree Programs/BbaAviation"));
const BbaAviationAndGroundHandling = lazy(() => import("./Pages/Training/Degree Programs/BbaAviationAndGroundHandling"));
const BscAviation = lazy(() => import("./Pages/Training/Degree Programs/BSc Aviation/BscAviation"));
const BtechAero = lazy(() => import("./Pages/Training/Degree Programs/Btech-aeronautical/Btech-aero"));
const BscAeroScience = lazy(() => import("./Pages/Training/Degree Programs/BscAeroScience"));
const MbaAviation = lazy(() => import("./Pages/Training/Degree Programs/MbaAviation"));
const CabinCrew = lazy(() => import("./Pages/Training/Diploma Programs/CabinCrew"));
// const PgDiplomaAME = lazy(() => import("./Pages/Training/Diploma Programs/PgDiplomaAME"));
const DiplomaInAirportManagement = lazy(() => import("./Pages/Training/Diploma Programs/DiplomaInAirportManagement"));
const ATPL = lazy(() => import("./Pages/Training/Pilot Training/ATPL"));
const DGCALC = lazy(() => import("./Pages/Training/Pilot Training/DGCALC"));
const DGCAMR = lazy(() => import("./Pages/Training/Pilot Training/DGCAMR"));
const DGCACN = lazy(() => import("./Pages/Training/Pilot Training/DGCACN"));
const DGCAEPL = lazy(() => import("./Pages/Training/Pilot Training/DGCAEPL"));
const ContactNew = lazy(() => import("./Pages/Contact/ContactNew"));
const LabEstablishment = lazy(() => import("./Pages/Consulting/LabEstablishment"));
const ACMI = lazy(() => import("./Pages/Consulting/ACMI"));
const FlightSimulator = lazy(() => import("./Pages/Innovation/FlightSimulator"));
const Cessna = lazy(() => import("./Pages/Flight Simulator/Cessna"));
const Airbus = lazy(() => import("./Pages/Flight Simulator/Airbus"));
const Boeing = lazy(() => import("./Pages/Flight Simulator/Boeing"));
const Gallery = lazy(() => import("./Pages/Gallery/Gallery"));
const Career = lazy(() => import("./Pages/Career/Career"));
const Pilot = lazy(() => import("./Pages/Career/Pages/TechnicalInstructorAviation"));
const AME = lazy(() => import("./Pages/Career/Pages/AssistantProfessorAviation"));
const GroundStaff = lazy(() => import("./Pages/Career/Pages/AssistantProfessorBBA"));
const FlightDispatch = lazy(() => import("./Pages/Career/Pages/FlightDispatch"));
const IT = lazy(() => import("./Pages/Career/Pages/IT"));
const DronePilot = lazy(() => import("./Pages/Career/Pages/DronePilot"));
const BDM = lazy(() => import("./Pages/Career/Pages/BusinessDevelopmentAssociate"));
const Finance = lazy(() => import("./Pages/Career/Pages/AssistantProfessorMBA"));
const Media = lazy(() => import("./Pages/Career/Pages/Media"));
// const Blogs = lazy(() => import("./Pages/Blogs/Blogs"));
// const Blog1 = lazy(() => import("./Pages/Blogs/Pages/Blog_1"));
// const Blog2 = lazy(() => import("./Pages/Blogs/Pages/Blog_2"));
// const Blog3 = lazy(() => import("./Pages/Blogs/Pages/Blog_3"));
// const Blog4 = lazy(() => import("./Pages/Blogs/Pages/Blog_4"));
// const Blog5 = lazy(() => import("./Pages/Blogs/Pages/Blog_5"));
// const Blog6 = lazy(() => import("./Pages/Blogs/Pages/Blog_6"));
// const Blog7 = lazy(() => import("./Pages/Blogs/Pages/Blog_7"));
// const Blog8 = lazy(() => import("./Pages/Blogs/Pages/Blog_8"));
// const Blog9 = lazy(() => import("./Pages/Blogs/Pages/Blog_9"));
// const Blog10 = lazy(() => import("./Pages/Blogs/Pages/Blog_10"));
// const Blog11 = lazy(() => import("./Pages/Blogs/Pages/Blog_11"));
// const Blog12 = lazy(() => import("./Pages/Blogs/Pages/Blog_12"));
// const Blog13 = lazy(() => import("./Pages/Blogs/Pages/Blog_13"));
// const Blog14 = lazy(() => import("./Pages/Blogs/Pages/Blog_14"));
// const Blog15 = lazy(() => import("./Pages/Blogs/Pages/Blog_15"));
// const Blog16 = lazy(() => import("./Pages/Blogs/Pages/Blog_16"));
// const Blog17 = lazy(() => import("./Pages/Blogs/Pages/Blog_17"));
// const Blog18 = lazy(() => import("./Pages/Blogs/Pages/Blog_18"));
// const Blog19 = lazy(() => import("./Pages/Blogs/Pages/Blog_19"));
// const Blog20 = lazy(() => import("./Pages/Blogs/Pages/Blog_20"));
// const Blog21 = lazy(() => import("./Pages/Blogs/Pages/Blog_21"));
// const Blog22 = lazy(() => import("./Pages/Blogs/Pages/Blog_22"));
// const Blog23 = lazy(() => import("./Pages/Blogs/Pages/Blog_23"));
// const Blog24 = lazy(() => import("./Pages/Blogs/Pages/Blog_24"));
// const Blog25 = lazy(() => import("./Pages/Blogs/Pages/Blog_25"));
const Students = lazy(() => import("./Pages/Students/Students"));
const Campus = lazy(() => import("./Pages/Students/Campus"));
const DGCAStudents = lazy(() => import("./Pages/Students/DGCAStudents"));
const VelsUniversity = lazy(() => import("./Pages/Colleges/2026-2027/VelsUniversity"));
const RathinamUniversity = lazy(() => import("./Pages/Colleges/2026-2027/RathinamUniversity"));
const GanpatUniversity = lazy(() => import("./Pages/Colleges/2026-2027/GanpatUniversity"));
const CrescentUniversity = lazy(() => import("./Pages/Colleges/2026-2027/CrescentUniversity"));
const JamalMohamedCollege = lazy(() => import("./Pages/Colleges/2026-2027/JamalMohamedCollege"));
const BharathUniversity = lazy(() => import("./Pages/Colleges/2026-2027/BharathUniversity"));
const BishopHeber = lazy(() => import("./Pages/Colleges/2026-2027/BishopHeber"));
const AllianceUniversity = lazy(() => import("./Pages/Colleges/2026-2027/AllianceUniversity"));
const Sasurie = lazy(() => import("./Pages/Colleges/2026-2027/SasurieCollege"));
const Sanskriti = lazy(() => import("./Pages/Colleges/2026-2027/SanskritiUniversity"));
const Kalasalingam = lazy(() => import("./Pages/Colleges/2026-2027/KalasalingamUniversity"));
const FixedWingElectricAircraft = lazy(() => import("./Pages/Innovation/FixedWingElectricAircraft"));
const PrivacyPolicy = lazy(() => import("./Pages/Privacy Policy/PrivacyPolicy"));
const CommunicationPolicy = lazy(() => import("./Pages/Privacy Policy/CommunicationPolicy"));
const TermsAndConditions = lazy(() => import("./Pages/Terms and conditions/TermsAndConditions"));
const Technology3D = lazy(() => import("./Pages/Technology/Technology3D"));
const MiraLms = lazy(() => import("./Pages/Technology/MiraLms"));
const AmeLms = lazy(() => import("./Pages/Technology/AmeLms"));
const VrArLms = lazy(() => import("./Pages/Technology/VrArLms"));
const FlightSimulatorLab = lazy(() => import("./Pages/Technology/FlightSimulatorLab"));
const AtcLab = lazy(() => import("./Pages/Technology/AtcLab"));

function App() {
  const [isBackgroundBlurred, setIsBackgroundBlurred] = useState(false);
  // const location = useLocation(); // ✅ reactive
  // const currentPageLink = location.pathname;

  const location = useLocation();

  React.useEffect(() => {
    let lenisInstance = null;
    let tickerCallback = null;
    let gsapInstance = null;

    Promise.all([
      import("lenis"),
      import("gsap"),
      import("gsap/ScrollTrigger"),
    ]).then(([{ default: Lenis }, { gsap }, { ScrollTrigger }]) => {
      gsap.registerPlugin(ScrollTrigger);
      const lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
        wheelMultiplier: 1,
        touchMultiplier: 2,
      });

      window.lenis = lenis;
      lenisInstance = lenis;
      gsapInstance = gsap;

      lenis.on("scroll", ScrollTrigger.update);

      tickerCallback = (time) => {
        lenis.raf(time * 1000);
      };

      gsap.ticker.add(tickerCallback);
      gsap.ticker.lagSmoothing(0);
    }).catch((err) => {
      console.warn("Smooth scroll initialization skipped:", err);
    });

    return () => {
      if (gsapInstance && tickerCallback) {
        gsapInstance.ticker.remove(tickerCallback);
      }
      if (lenisInstance) {
        lenisInstance.destroy();
        window.lenis = null;
      }
    };
  }, []);

  // const path = location.pathname.replace(/\/$/, ""); // fix trailing slash
  const faqContent = faqsByRoute[location.pathname];

  return (
    <div className="scroll-smooth">

      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "@id": "https://mhcockpit.com/#organization",
            "name": "MH Cockpit Pvt Ltd",
            "legalName": "MH Cockpit Pvt Ltd",
            "url": "https://mhcockpit.com/",
            "description":
              "MH Cockpit, a Top Aviation College in Chennai, offers UGC-approved courses. Learn from aviation professionals and launch your career.",
            "logo":
              "https://mhcockpit.com/MH_Cockpit_TM_LOGO_transparent.png",
            "image":
              "https://mhcockpit.com/Media/Home/Converted/Pilots.webp",
            "email": "info@mhcockpit.com",
            "telephone": "+91-7305952831",

            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Tower-B, Featherlite The Address",
              "addressLocality": "Pallavaram",
              "addressRegion": "Tamil Nadu",
              "postalCode": "600043",
              "addressCountry": "IN"
            },

            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-7305952831",
              "contactType": "customer service",
              "areaServed": "IN",
              "availableLanguage": ["English", "Tamil"]
            },

            "sameAs": [
              "https://www.facebook.com/MHCockpitAviationAcademy/",
              "https://www.youtube.com/@mhcockpit",
              "https://www.linkedin.com/company/mhcockpit/",
              "https://x.com/mhcockpitpvtltd",
              "https://www.instagram.com/mh_cockpit/"
            ]
          })
        }}
      />

      {/* Breadcrumb Schema */}
      <BreadcrumbSchema />

      {/* Cookies */}
      <Suspense fallback={null}>
        <CookieConsent />
      </Suspense>

      {/* <SchemaRenderer /> */}

      {/* <MetaDescription pageLink={currentPageLink} /> */}
      <MetaRouteWrapper />   {/* ✅ must be here */}

      {/* FAQ Schema */}
      <FaqSchema />

      {/* Video Schema */}
      <VideoSchema />

      <Navbar setBackgroundBlur={setIsBackgroundBlurred} />

      <div id="background" className={`pt-12 ${isBackgroundBlurred ? '' : ''}`}>
        <ScrollToTop />

        {/* ✅ Wrap Routes in Suspense */}
        <Suspense fallback={
          <div className="h-screen flex items-center justify-center text-xl font-semibold">
            Loading...
          </div>
        }>
          <Routes>
            <Route path="/" element={<HomeUpdate />} />
            <Route path="/training" element={<TrainingNew />} />
            <Route path="/training/private-pilot-license" element={<PPL />} />
            <Route path="/training/commercial-pilot-license" element={<Cpl />} />
            <Route path="/training/type-rating" element={<TypeRating />} />
            <Route path="/training/airline-transport-pilot-license" element={<ATPL />} />
            <Route path="/training/dgca-license-conversion" element={<DGCALC />} />
            <Route path="/training/dgca-medical-requirements" element={<DGCAMR />} />
            <Route path="/training/dgca-pilot-computer-number" element={<DGCACN />} />
            <Route path="/training/electronic-personnel-license-epl" element={<DGCAEPL />} />
            {/* <Route path="/training/dgca-electronic-personnel-licence" element={<Navigate to="/training/electronic-personnel-license-epl" replace />} /> */}
            <Route path="/training/bba-aviation-management" element={<BbaAviation />} />
            <Route path="/training/bba-aviation-and-ground-handling" element={<BbaAviationAndGroundHandling />} />
            <Route path="/training/bsc-aviation" element={<BscAviation />} />
            <Route path="/training/btech-aeronautical-engineering" element={<BtechAero />} />
            <Route path="/training/bsc-aeronautical-science" element={<BscAeroScience />} />
            <Route path="/training/mba-aviation-and-airport-management" element={<MbaAviation />} />
            <Route path="/training/cabin-crew" element={<CabinCrew />} />
            <Route path="/training/pg-diploma-in-aircraft-maintenance" element={<Navigate to="/" replace />} />
            <Route path="/training/certification-in-airport-management" element={<DiplomaInAirportManagement />} />
            <Route path="/contact" element={<ContactNew />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/about-us/our-governance" element={<OurGovernance />} />
            <Route path="/about-us/our-values" element={<OurValues />} />
            <Route path="/about-us/our-presence" element={<OurPresence />} />
            <Route path="/colleges" element={<Colleges />} />
            <Route path="/for-universities" element={<ForUniversities />} />
            <Route path="/consulting" element={<Consulting />} />
            <Route path="/consulting/lab-infrastructure" element={<LabEstablishment />} />
            <Route path="/consulting/aircraft-leasing-and-financing" element={<ACMI />} />
            <Route path="/innovation" element={<Innovation />} />
            <Route path="/innovation/fixed-wing" element={<FixedWingElectricAircraft />} />
            <Route path="/innovation/flight-simulator" element={<FlightSimulator />} />
            <Route path="/innovation/flight-simulator/cessna" element={<Cessna />} />
            <Route path="/innovation/flight-simulator/airbus" element={<Airbus />} />
            <Route path="/innovation/flight-simulator/boeing" element={<Boeing />} />
            <Route path="/students/gallery" element={<Gallery />} />
            <Route path="/gallery" element={<Navigate to="/students/gallery" replace />} />
            <Route path="/careers" element={<Career />} />
            <Route path="/careers/assistant-professor-aviation" element={<AME />} />
            <Route path="/careers/ame-instructor" element={<AME />} />
            <Route path="/careers/technical-instructor-aviation" element={<Pilot />} />
            <Route path="/careers/pilot-ground-instructor" element={<Pilot />} />
            <Route path="/careers/assistant-professor-mba-aviation" element={<Finance />} />
            <Route path="/careers/finance" element={<Finance />} />
            <Route path="/careers/assistant-professor-bba-aviation" element={<GroundStaff />} />
            <Route path="/careers/ground-operations-trainer" element={<GroundStaff />} />
            <Route path="/careers/business-development-associate" element={<BDM />} />
            <Route path="/careers/bdm" element={<BDM />} />
            <Route path="/careers/cabin-crew-instructor" element={<Navigate to="/careers" replace />} />
            <Route path="/careers/flight-dispatch" element={<FlightDispatch />} />
            <Route path="/careers/it" element={<IT />} />
            <Route path="/careers/drone-pilots" element={<DronePilot />} />
            <Route path="/careers/media" element={<Media />} />
            {/* <Route path="/blogs" element={<Blogs />} /> */}
            <Route path="/students" element={<Students />} />
            <Route path="/students/campus" element={<Campus />} />
            <Route path="/students/dgca-exams-cleared" element={<DGCAStudents />} />
            <Route path="/colleges/vels-university" element={<VelsUniversity />} />
            <Route path="/colleges/rathinam-university" element={<RathinamUniversity />} />
            <Route path="/colleges/bharath-university" element={<BharathUniversity />} />
            <Route path="/colleges/ganpat-university" element={<GanpatUniversity />} />
            <Route path="/colleges/crescent-university" element={<CrescentUniversity />} />
            <Route path="/colleges/jamal-mohamed-college" element={<JamalMohamedCollege />} />
            <Route path="/colleges/bishop-heber-college" element={<BishopHeber />} />
            <Route path="/colleges/kalasalingam-university" element={<Kalasalingam />} />
            <Route path="/colleges/sasurie-college" element={<Sasurie />} />
            <Route path="/colleges/alliance-university" element={<AllianceUniversity />} />
            <Route path="/colleges/sanskriti-university" element={<Sanskriti />} />
            {/* <Route path="/colleges" element={<CollegesLayout />}>
              <Route path="vels-university" element={<VelsUniversity />} />
              <Route path="crescent-university" element={<CrescentUniversity />} />
              <Route path="jamal-mohamed-college" element={<JamalMohamedCollege />} />
              <Route path="bharath-university" element={<BharathUniversity />} />
              <Route path="bishop-heber-college" element={<BishopHeber />} />
              <Route path="alliance-university" element={<AllianceUniversity />} />
              <Route path="sasurie-college" element={<Sasurie />} />
              <Route path="sanskriti-university" element={<Sanskriti />} />
              <Route path="kalasalingam-university" element={<Kalasalingam />} />
            </Route> */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/communication-policy" element={<CommunicationPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

            {/* All Blogs */}
            {/* {{
              1: Blog1, 2: Blog2, 3: Blog3, 4: Blog4, 5: Blog5,
              6: Blog6, 7: Blog7, 8: Blog8, 9: Blog9, 10: Blog10,
              11: Blog11, 12: Blog12, 13: Blog13, 14: Blog14, 15: Blog15,
              16: Blog16, 17: Blog17, 18: Blog18, 19: Blog19, 20: Blog20,
              21: Blog21, 22: Blog22, 23: Blog23, 24: Blog24, 25: Blog25
            }} */}

            <Route path="/blogs" element={<BlogListPage />} />
            <Route path="/blogs/education-loan-emi-calculator" element={<Blog26 />} />
            <Route path="/blogs/bba-aviation-management-full-course-details" element={<Navigate to="/blogs/bba-aviation-careers-salary-india-guide-freshers" replace />} />
            <Route path="/blogs/bba-aviation-management-complete-guide" element={<Navigate to="/blogs/bba-aviation-careers-salary-india-guide-freshers" replace />} />
            <Route path="/blogs/dgr-training-aviation-categories-careers" element={<Navigate to="/blogs/dgr-in-aviation-what-bba-students-must-know" replace />} />
            <Route path="/blogs/:slug" element={
              <>
                <BlogSeoWrapper />
                <BlogPage />
              </>} />
            <Route path="/blogs/author/:slug" element={<EmployeePage />} />

            {/* <Route path="/blogs/the-impact-of-artificial-intelligence-on-aviation" element={<Blog1 />} />
            <Route path="/blogs/exploring-career-opportunities-in-aviation" element={<Blog2 />} />
            <Route path="/blogs/a-day-in-the-life-of-an-aviation-student" element={<Blog3 />} />
            <Route path="/blogs/deciding-between-studying-cpl-abroad-or-in-india" element={<Blog4 />} />
            <Route path="/blogs/the-development-of-electric-and-hybrid-aircraft" element={<Blog5 />} />
            <Route path="/blogs/emerging-technologies-in-aviation" element={<Blog6 />} />
            <Route path="/blogs/flying-high-why-choosing-the-aviation-industry" element={<Blog7 />} />
            <Route path="/blogs/navigating-the-skies" element={<Blog8 />} />
            <Route path="/blogs/demand-for-pilots" element={<Blog9 />} />
            <Route path="/blogs/how-the-pandemic-reshaped-air-travel" element={<Blog10 />} />
            <Route path="/blogs/the-future-of-aviation-careers" element={<Blog11 />} />
            <Route path="/blogs/the-benefits-of-an-aviation-degree" element={<Blog12 />} />
            <Route path="/blogs/your-journey-to-become-a-pilot" element={<Blog13 />} />
            <Route path="/blogs/mh-cockpit-ranked-as-one-of-indias-top-bsc-aviation-colleges" element={<Blog14 />} />
            <Route path="/blogs/the-future-of-urban-air-mobility" element={<Blog15 />} />
            <Route path="/blogs/zooming-high-celebrating-women-in-aviation" element={<Blog16 />} />
            <Route path="/blogs/nurturing-future-aviators" element={<Blog17 />} />
            <Route path="/blogs/exciting-internship-opportunities" element={<Blog18 />} />
            <Route path="/blogs/tips-for-a-successful-aviation-career-journey" element={<Blog19 />} />
            <Route path="/blogs/big-data-taking-flight" element={<Blog20 />} />
            <Route path="/blogs/air-traffic-management" element={<Blog21 />} />
            <Route path="/blogs/the-impact-of-cybersecurity-on-aviation" element={<Blog22 />} />
            <Route path="/blogs/different-types-of-aviation-degrees" element={<Blog23 />} />
            <Route path="/blogs/the-best-aviation-schools-and-programs" element={<Blog24 />} />
            <Route path="/blogs/tamil-nadu-your-launchpad-for-an-aviation-career-in-india" element={<Blog25 />} /> */}

            <Route path="/technology" element={<Technology3D />} />
            <Route path="/mira-lms" element={<Navigate to="/technology/mira-lms" replace />} />
            <Route path="/technology/mira-lms" element={<MiraLms />} />
            <Route path="/ame-lms" element={<Navigate to="/technology/ame-lms" replace />} />
            <Route path="/technology/ame-lms" element={<AmeLms />} />
            <Route path="/vr-ar-lms" element={<Navigate to="/technology/vr-ar-lms" replace />} />
            <Route path="/technology/vr-ar-lms" element={<VrArLms />} />
            <Route path="/flight-simulator-lab" element={<Navigate to="/technology/flight-simulator-lab" replace />} />
            <Route path="/technology/flight-simulator-lab" element={<FlightSimulatorLab />} />
            <Route path="/air-traffic-control-lab" element={<Navigate to="/technology/air-traffic-control-lab" replace />} />
            <Route path="/technology/air-traffic-control-lab" element={<AtcLab />} />


            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Suspense>

        <BackToTopButton />
      </div>


      {/* Render FAQ only if available */}
      {faqContent && (
        <Suspense fallback={null}>
          <FaqSection
            titleColor={faqContent.titleColor}
            faqData={faqContent.items}
          />
        </Suspense>
      )}

      <FooterNew />
      <Suspense fallback={null}>
        <FloatingContactActions />
      </Suspense>
    </div>
  );
}

export default App;
